import * as Types from '../../../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SuppliedAccessoriesSkuQueryVariables = Types.Exact<{
  subscriptionSku: Types.Scalars['String'];
  accessoriesTypes: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type SuppliedAccessoriesSkuQuery = { __typename?: 'query_root', subscriptionAccessoriesSkus: { __typename?: 'CatalogItemsSkus', catalogItemSkus: any } };


export const SuppliedAccessoriesSkuDocument = gql`
    query suppliedAccessoriesSku($subscriptionSku: String!, $accessoriesTypes: [String!]!) {
  subscriptionAccessoriesSkus: nest_customerGetSubscriptionAccessoriesSkus(
    subscriptionSku: $subscriptionSku
    accessoriesTypes: $accessoriesTypes
  ) {
    catalogItemSkus
  }
}
    `;
export function useSuppliedAccessoriesSkuQuery(baseOptions: Apollo.QueryHookOptions<SuppliedAccessoriesSkuQuery, SuppliedAccessoriesSkuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuppliedAccessoriesSkuQuery, SuppliedAccessoriesSkuQueryVariables>(SuppliedAccessoriesSkuDocument, options);
      }
export function useSuppliedAccessoriesSkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppliedAccessoriesSkuQuery, SuppliedAccessoriesSkuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuppliedAccessoriesSkuQuery, SuppliedAccessoriesSkuQueryVariables>(SuppliedAccessoriesSkuDocument, options);
        }
export type SuppliedAccessoriesSkuQueryHookResult = ReturnType<typeof useSuppliedAccessoriesSkuQuery>;
export type SuppliedAccessoriesSkuLazyQueryHookResult = ReturnType<typeof useSuppliedAccessoriesSkuLazyQuery>;
export type SuppliedAccessoriesSkuQueryResult = Apollo.QueryResult<SuppliedAccessoriesSkuQuery, SuppliedAccessoriesSkuQueryVariables>;